import React from 'react';
import PropTypes from 'prop-types';
import ReactRating from 'react-rating';
import cn from 'classnames';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';

import Image from 'components/Image';
import iconShield from 'images/icon_shield.svg';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  formControl: {
    display: 'flex',
    marginBottom: '1rem',
  },
  ratings: {
    marginTop: '1rem',
  },
  empty: {
    filter: 'invert(0.5)',
  },
}));

const Rating = ({ className, required, label, error, onChange, value }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <FormControl
      className={cn(classes.formControl, className)}
      required={required}
      error={error}
    >
      <InputLabel shrink>{t(label)}</InputLabel>
      <div className={classes.ratings}>
        <ReactRating
          initialRating={value}
          emptySymbol={<Image src={iconShield} className={classes.empty} />}
          fullSymbol={<Image src={iconShield} />}
          onChange={onChange}
        />
      </div>

      {error && (
        <FormHelperText id="component-error-text">{error}</FormHelperText>
      )}
    </FormControl>
  );
};

Rating.propTypes = {
  className: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Rating;
